module.exports = __webpack_public_path__ + "static/media/logo-rc-reg2021-en.0d1fa551.svg";